import type { ICommandMenuAction } from './ICommandMenuAction.js'
import { NordEvent } from '../common/events.js'

export class SelectEvent extends NordEvent {
  static eventName = 'nord-select'

  constructor(public command: ICommandMenuAction) {
    super(SelectEvent.eventName)
  }
}
